import { Redirect } from '#app/components/Redirect/index.js';
import { useToast } from '#app/components/Toasts/hooks/useToast.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { logger } from '#app/services/logger.js';
import { useMount } from '@contra/react-hooks/useMount';
import { getRoute } from '@contra/routes';

export const Page = () => {
  const currentUser = useCurrentUser();
  const toast = useToast();
  useMount(() => {
    if (currentUser) {
      toast(
        'Notifications page has moved! Access it from the bell icon on the navbar.',
        { role: 'status' },
      );
    }
  });

  if (!currentUser) {
    logger.warn(
      {
        currentUser,
      },
      'redirecting unauthenticated user to login',
    );

    return (
      <Redirect
        method="push"
        to={getRoute('/log-in')}
      />
    );
  }

  return (
    <Redirect
      method="replace"
      to={getRoute('/')}
    />
  );
};
